var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useState } from 'react';
import { useRevalidator } from 'react-router-dom';
import { useSetAtom } from 'jotai';

import { Translate } from "../../../../../I18N";

import { FileDropzone } from "../../../../Components/Forms";
import { Button, Modal } from "../../../../Components/UI";

import { uploadProgressAtom } from "./uploadProgressAtom";








const DropzoneModal = ({ notify, isOpen, setIsOpen, uploadService }) => {
  const revalidator = useRevalidator();
  const [filesToUpload, setFilesToUpload] = useState([]);
  const updateProgress = useSetAtom(uploadProgressAtom);

  const handleCancel = () => {
    setIsOpen(false);
    setFilesToUpload([]);
  };

  const handleSave = async () => {
    setIsOpen(false);
    uploadService.onProgress((filename, progress) => {
      updateProgress({ filename, progress });
    });
    uploadService.onUploadComplete(() => {
      revalidator.revalidate();
    });
    const results = await uploadService.upload([...filesToUpload]);
    updateProgress({ filename: undefined, progress: undefined });
    notify(results, /*#__PURE__*/_jsx(Translate, {}, void 0, "Uploaded custom file"));
  };

  return isOpen ? /*#__PURE__*/
  _jsx(Modal, { size: "xl" }, void 0, /*#__PURE__*/
  _jsx(Modal.Header, {}, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "Import asset"), /*#__PURE__*/
  _jsx(Modal.CloseButton, {
    onClick: () => {
      handleCancel();
    } }
  )
  ), /*#__PURE__*/
  _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
  _jsx(FileDropzone, {
    className: "w-auto md:min-w-72",
    onChange: (newFiles) => {
      setFilesToUpload(newFiles);
    } }
  )
  ), /*#__PURE__*/
  _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
  _jsx("div", { className: "flex w-full" }, void 0, /*#__PURE__*/
  _jsx("div", { className: "flex gap-4" }, void 0, /*#__PURE__*/
  _jsx(Button, {
    className: "w-1/2",
    styling: "outline",
    onClick: () => {
      handleCancel();
    } }, void 0, /*#__PURE__*/

  _jsx(Translate, {}, void 0, "Cancel")
  ), /*#__PURE__*/
  _jsx(Button, { className: "w-1/2", onClick: async () => handleSave() }, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "Add")
  )
  )
  )
  )
  ) : /*#__PURE__*/

  _jsx("div", {});

};

export { DropzoneModal };